import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeAccordionContentItemSkeleton } from './TypeAccordionContentItem';

export interface TypeBlockAccordionContentFields {
    internalName: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Text;
    paragraph?: EntryFieldTypes.Text;
    items: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeAccordionContentItemSkeleton>>;
}

export type TypeBlockAccordionContentSkeleton = EntrySkeletonType<
    TypeBlockAccordionContentFields,
    'blockAccordionContent'
>;
export type TypeBlockAccordionContent<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeBlockAccordionContentSkeleton, Modifiers, Locales>;

export function isTypeBlockAccordionContent<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockAccordionContent<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockAccordionContent';
}
